import { useCallback, useSyncExternalStore } from 'react'

import echo from '@/lib/echo'

export type EchoConnection = 'connecting' | 'connected' | 'unavailable'

/**
 * Der Verbindungszustand lebt im pusher-js-Client, also ausserhalb von React.
 * useSyncExternalStore liest ihn beim Rendern frisch aus und abonniert die
 * Aenderungen - kein setState im Effekt und keine Race zwischen Mount und
 * einem bereits gefeuerten "connected"-Event.
 */
export function useEchoConnection(): EchoConnection {
    const subscribe = useCallback((onStoreChange: () => void) => {
        const { connection } = echo.connector.pusher

        connection.bind('state_change', onStoreChange)

        return () => connection.unbind('state_change', onStoreChange)
    }, [])

    const getSnapshot = useCallback((): EchoConnection => {
        switch (echo.connector.pusher.connection.state) {
            case 'connected':
                return 'connected'
            case 'unavailable':
            case 'failed':
                return 'unavailable'
            default:
                return 'connecting'
        }
    }, [])

    return useSyncExternalStore(subscribe, getSnapshot, () => 'connecting' as const)
}
